import {
  type ApiResponse,
  type PaginatedResponse
} from '../../api-client';

import {
  apiRequest
} from './client';

import type {
  TaxRate,
  CreateTaxRateInput,
  UpdateTaxRateInput,
  CreateLineItemInput,
  UpdateLineItemInput
} from './types/catalog.types';

import type {
  LineItem
} from './types/quotes.types';

// ── Tax Rates ─────────────────────────────────────────────────────────────────

export interface ListTaxRatesParams {
  limit?: number
  offset?: number
}

export async function listTaxRates(
  params: ListTaxRatesParams = {},
  token: string
): Promise<PaginatedResponse<TaxRate>> {

  const query = new URLSearchParams();

  if (params.limit !== undefined) {

    query.set('limit', String(params.limit));
  }

  if (params.offset !== undefined) {

    query.set('offset', String(params.offset));
  }

  const qs = query.size > 0 ? `?${ query.toString() }` : '';
  return apiRequest<PaginatedResponse<TaxRate>>(`/tax-rates${ qs }`, undefined, token);
}

export async function createTaxRate(
  input: CreateTaxRateInput,
  token: string
): Promise<ApiResponse<TaxRate>> {

  return apiRequest<ApiResponse<TaxRate>>(
    '/tax-rates',
    {
      method: 'POST',
      body: JSON.stringify(input)
    },
    token
  );
}

export async function updateTaxRate(
  id: number,
  input: UpdateTaxRateInput,
  token: string
): Promise<ApiResponse<TaxRate>> {

  return apiRequest<ApiResponse<TaxRate>>(
    `/tax-rates/${ id }`,
    {
      method: 'PUT',
      body: JSON.stringify(input)
    },
    token
  );
}

// ── Line Items ────────────────────────────────────────────────────────────────

export interface ListLineItemsQueryParams {
  limit?: number
  offset?: number
}

export async function listAllLineItems(
  params: ListLineItemsQueryParams = {},
  token: string
): Promise<PaginatedResponse<LineItem>> {

  const query = new URLSearchParams();

  if (params.limit !== undefined) {

    query.set('limit', String(params.limit));
  }

  if (params.offset !== undefined) {

    query.set('offset', String(params.offset));
  }

  const qs = query.size > 0 ? `?${ query.toString() }` : '';
  return apiRequest<PaginatedResponse<LineItem>>(`/line-items${ qs }`, undefined, token);
}

export async function createLineItem(
  input: CreateLineItemInput,
  token: string
): Promise<ApiResponse<LineItem>> {

  return apiRequest<ApiResponse<LineItem>>(
    '/line-items',
    {
      method: 'POST',
      body: JSON.stringify(input)
    },
    token
  );
}

export async function updateLineItem(
  id: number,
  input: UpdateLineItemInput,
  token: string
): Promise<ApiResponse<LineItem>> {

  return apiRequest<ApiResponse<LineItem>>(
    `/line-items/${ id }`,
    {
      method: 'PUT',
      body: JSON.stringify(input)
    },
    token
  );
}

export async function deleteLineItem(
  id: number,
  token: string
): Promise<ApiResponse<void>> {

  return apiRequest<ApiResponse<void>>(
    `/line-items/${ id }`,
    {
      method: 'DELETE'
    },
    token
  );
}
